module.exports = __webpack_public_path__ + "static/media/victory.61c34d15.svg";